<div class="main-container">
  <div class="ui grid">
    <div class="sixteen wide column">
      <h1>
        <i class="file dollar icon icon"></i> Payment Details
      </h1>
    </div>

    <!-- Main Content -->
    <div class="sixteen wide mobile eight wide tablet nine wide computer column payment-form-column">
      <div class="ui form settings">
        <p>Review your subscription and enter your payment details</p>

        <div v-if="hasActiveSubscription" class="ui warning message payment-replace-warning">
          <div class="header">This will replace your current subscription</div>
          <p>
            You already have an active plan. Subscribing will cancel it and replace it with this
            {{ interval === 'yearly' ? 'yearly' : 'monthly' }} plan.
          </p>
        </div>

        <app-stripe-card-fields ref="stripeFields" />

        <div class="field settings payment-referral-field">
          <app-field-label>Referral code (optional)</app-field-label>
          <app-text-input
            :model-value="referralCode"
            placeholder="Enter referral code"
            autocomplete="off"
            @update:model-value="onReferralCodeInput"
          />
        </div>

        <div
          class="ui fluid primary button"
          :class="{ loading: submitting, disabled: submitting }"
          v-on:click="tokenize()"
        >
          Subscribe Now
        </div>

        <br>
        <p>
          <i class="lock icon icon"></i> This is a secure 128-SSL encrypted connection.
        </p>
        <br>
      </div>
    </div>

    <!-- Side Panel-->
    <div class="sixteen wide mobile eight wide tablet seven wide computer column payment-summary-column">
        <div class="ui right aligned grid">
          <div class="sixteen wide column">
            <a class="primary" href="/settings/plans">Change plan</a>
          </div>
        </div>
        <div class="pricing-details-box">
          <div class="sixteen wide column">
            <h1>{{ interval === 'yearly' ? 'Yearly' : 'Monthly' }}</h1>
            <p v-if="hasActiveSubscription">
              Subscribing will cancel your current plan and start this billing cycle.
            </p>
            <p v-else>
              All plans include a 14-day free trial. After the trial you'll be charged according to your chosen billing cycle.
            </p>
          </div>

          <div class="sixteen wide column spacer two">
            <i class="check green circle outline icon"></i> Send unlimited quote &amp; invoices <br>
            <i class="check green circle outline icon"></i> Add unlimited employees <br>
            <i class="check green circle outline icon"></i> Smardie branding removed <br>
            <i class="check green circle outline icon"></i> Priority support <br>
          </div>

          <div class="ui grid spacer four" v-if="interval === 'yearly'">
            <div class="sixteen wide column">
              <div class="pricing-details-header">$820</div>
              <div class="pricing-details-sub-text"> /year</div>
              <div class="pricing-details-description">$68.30 per month (billed annually)</div>
            </div>
          </div>
          <div class="ui grid spacer four" v-else>
            <div class="sixteen wide column">
              <div class="pricing-details-header">$85</div>
              <div class="pricing-details-sub-text"> /month</div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
